import { useRef } from 'react';
import { useIsStickyElementPinned } from 'app/lib/hooks';
import * as styles from './DialogWithChapters.css';

function preventDefault(event) {
    event.preventDefault();
}

export function DialogPanel({ id, label, open, children }) {
    const ref = useRef();
    const isPinned = useIsStickyElementPinned(ref);

    return (
        <details id={id} className={styles.panel} open={open}>
            <summary
                ref={ref}
                className={styles.header}
                onClick={preventDefault}
                data-pinned={isPinned}>
                <div className={styles.label}>{label}</div>
            </summary>
            {children}
        </details>
    );
}
